"use client";

/**
 * Guest marketing home — same sections as `src/v2/pages/Home`.
 * Header/footer and top offset come from `LayoutShell` (v2 chrome).
 */
import V2Home from "@/v2/pages/Home";

export function V2MarketingHomeShell() {
  return <V2Home />;
}
